module.exports = __webpack_public_path__ + "img/work-together-restaurants.df971625.jpg";